var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6252_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7244 22.7692H17.6633L20.2034 7.28076H24.2643L21.7244 22.7692Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4464 7.6594C35.6454 7.34602 34.3749 7 32.8039 7C28.7934 7 25.9692 9.10895 25.9519 12.1241C25.9186 14.3487 27.9739 15.5843 29.5111 16.326C31.0824 17.084 31.6165 17.5787 31.6165 18.2543C31.6005 19.2919 30.3468 19.7702 29.1776 19.7702C27.5562 19.7702 26.6874 19.5236 25.3672 18.9463L24.8324 18.6989L24.2641 22.1757C25.2166 22.6036 26.9715 22.9834 28.7934 23C33.0546 23 35.8288 20.9237 35.8617 17.7105C35.8779 15.9474 34.7926 14.5964 32.4528 13.4924C31.0324 12.7837 30.1625 12.3059 30.1625 11.5808C30.1792 10.9216 30.8983 10.2464 32.5017 10.2464C33.8219 10.2134 34.792 10.5263 35.5268 10.8395L35.8941 11.0039L36.4464 7.6594Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8441 17.2822C42.1785 16.3924 43.4655 12.9487 43.4655 12.9487C43.4486 12.9817 43.7992 12.0424 43.9998 11.4658L44.2836 12.8004C44.2836 12.8004 45.0527 16.5078 45.2197 17.2822C44.585 17.2822 42.6462 17.2822 41.8441 17.2822ZM46.857 7.28076H43.7157C42.747 7.28076 42.0111 7.56064 41.5931 8.56584L35.5608 22.769H39.822C39.822 22.769 40.5236 20.8573 40.6744 20.4456C41.1418 20.4456 45.2872 20.4456 45.8886 20.4456C46.0051 20.9894 46.3731 22.769 46.3731 22.769H50.1334L46.857 7.28076Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2712 7.28076L10.294 17.8424L9.85938 15.7004C9.12408 13.2288 6.81801 10.5434 4.24457 9.20816L7.88755 22.7528H12.1821L18.5655 7.28076H14.2712Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60084 7.28076H0.0668454L0 7.59371C5.09693 8.87901 8.47252 11.9772 9.8594 15.701L8.43899 8.58271C8.20514 7.59349 7.48649 7.31339 6.60084 7.28076Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6252_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f58cadc4ce8419e07ad6b692e0458b5f.svg";
export { ForwardRef as ReactComponent };